import { CtaButton, Spinner, TrashCan } from '@zappyrent/hundop';
import { rem, rgba } from 'polished';
import styled from 'styled-components';

import { IStyledButtonProps } from './ListingDetail.types';

export const StyledTitle = styled.h2`
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('32px')};
  font-weight: 500;
  margin: 0;
  margin-top: ${rem('16px')};
`;

export const StyledBackTitle = styled.h2`
  color: ${({ theme }) => theme.colors.landlord.main};
  font-size: ${rem('16px')};
  font-weight: 700;
  margin: 0;
`;

export const StyledContractInfoTitle = styled.h3`
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('24px')};
  font-weight: 700;
  margin: 0;
`;

export const StyledCadastralDateTitle = styled.h3`
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('24px')};
  font-weight: 700;
  margin-top: ${rem('64px')};
  margin-bottom: ${rem('24px')};
`;

export const StyledAddDocumentTitle = styled.h3`
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('24px')};
  font-weight: 700;
  margin-top: ${rem('64px')};
  margin-bottom: ${rem('24px')};
`;

export const StyledAddOwnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-item: center;
  margin-top: ${rem('64px')};
  margin-bottom: ${rem('24px')};
`;

export const StyledButton = styled.button<IStyledButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: ${({ disabled }) => {
    if (disabled) return 'not-allowed';

    return 'pointer';
  }};
  appearance: none;

  &:not(:first-child) {
    margin-left: ${rem('12px')};
  }

  & svg path {
    fill: ${({ theme, disabled }) => {
      if (disabled) return '#EBEBE4';

      return theme.colors.cross.grayson;
    }};
  }

  & svg {
    cursor: ${({ disabled }) => {
      if (disabled) return 'not-allowed';

      return 'pointer';
    }};
  }
`;

export const StyledTrashCan = styled(TrashCan)`
  width: ${rem('16px')};
  cursor: pointer;
`;

export const StyledAddOwnerTitle = styled.h3`
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('24px')};
  font-weight: 700;
`;

export const StyledBackTitleWrapper = styled.div`
  display: inline-flex;
  gap: ${rem('9px')};
  align-items: center;
  cursor: pointer;
`;

export const StyledIntroWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledSubInfo = styled.h2`
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('18px')};
  font-weight: 400;
  margin: 0;
  margin-top: ${rem('16px')};
`;

export const StyledSubInfoSpan = styled.span`
  font-weight: 700;
`;

export const StyledListings = styled.section`
  display: grid;
  grid-template-columns: max(${rem('441px')});
  gap: ${rem('32px')};
  padding-top: ${rem('32px')};
  padding-bottom: ${rem('64px')};
  width: 100%;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.m}) {
    grid-template-columns: 1fr;
  }
`;

export const StyledAddOwnerCta = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${rem('24px')} ${rem('16px')};
  margin-top: ${rem('32px')};
  margin-bottom: ${rem('113px')};
  background-color: transparent;
  border: ${rem('1px')} dashed ${({ theme }) => theme.colors.cross.grayson};
  border-radius: ${rem('8px')};
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('14px')};
  font-weight: 700;
  text-transform: uppercase;
  appearance: none;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) =>
      rgba(theme.colors.landlord.mainPale, 0.5)};
    border-color: ${({ theme }) => theme.colors.landlord.main};
  }
`;

export const StyledAddOwnerCtaIcon = styled.span`
  svg {
    width: ${rem('32px')};
    height: ${rem('32px')};

    path {
      fill: black;
    }
  }
`;

export const StyledAddOwnerCtaLabel = styled.span`
  display: flex;
  flex-direction: row;
  align-items: baseline;

  &::after {
    width: ${rem('24px')};
    height: ${rem('24px')};
    margin-left: ${rem('8px')};
    color: ${({ theme }) => theme.colors.main};
    font-size: ${rem('20px')};
    font-weight: 700;
    background-color: ${({ theme }) => theme.colors.landlord.main};
    border-radius: 100%;
    content: '+';
    overflow: hidden;
  }
`;

export const StyledSubmitButtonWrapper = styled.div`
  padding: ${rem('32px')} ${rem('64px')};
  background: ${({ theme }) => theme.colors.main};
  box-shadow: 9px -4px 24px 0px #0000000d;
  margin: ${rem('0px')} ${rem('-60px')};
  text-align: right;
  justify-content: flex-end;
  display: flex;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    margin: ${rem('0px')} ${rem('-23px')};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin: ${rem('0px')} ${rem('-60px')};
  }
`;

export const StyledSubmitCtaButton = styled(CtaButton)`
  padding: ${rem('16px')} ${rem('70.5px')};
  font-weight: 700;
  font-size: ${rem('14px')};
  text-transform: uppercase;
  cursor: pointer;
  display: flex;

  &:not(:first-child) {
    margin-left: ${rem('12px')};
  }
`;

export const StyledSpinner = styled(Spinner)`
  margin-right: ${rem('5px')};
`;

export const StyledMissingFieldTitle = styled.h4`
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  font-size: ${rem('16px')};
  margin-bottom: ${rem('10px')};
  margin-top: 0;
`;

export const StyledMissingFieldWrapper = styled.div`
  margin-bottom: ${rem('30px')};
`;

export const StyledMissingFieldLabelsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${rem('8px')};
  margin-bottom: ${rem('8px')};
`;

export const StyledMissingFieldsText = styled.span`
  background-color: ${({ theme }) => rgba(theme.colors.cross.red, 0.1)};
  color: ${({ theme }) => theme.colors.cross.red};
  border-radius: ${rem('8px')};
  padding: ${rem('4px')} ${rem('8px')};
  font-weight: 600;

  display: inline-flex;
  align-items: center;
  gap: ${rem('8px')};
  font-size: ${rem('12px')};
`;

export const StyledMissingFieldLabel = styled.h4`
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  font-size: ${rem('14px')};
  margin: 0;
`;
